import Modal from "react-bootstrap/Modal";
import React, {useEffect, useState, useRef, useCallback} from "react";
import Button from "react-bootstrap/Button";
import {FileUploader, NumberBox, Template, DateBox, SelectBox} from 'devextreme-react';
import apiClient, {baseUrl} from '../../services/axios/index'
import LoaderService from "../../RetroAssets.System/LoaderService";
import {alert, confirm} from "devextreme/ui/dialog";
import cl from "../../RetroAssets.System/Utilities";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import {TextBox, ValidationGroup} from "devextreme-react";
import {Button as DataGridButton, Column, DataGrid, Summary, TotalItem} from "devextreme-react/data-grid";
import {ContextMenuTemplate, MoreOptionsButton} from "../../RetroAssets.System/MoreOptionsButton";
import InputGroup from "react-bootstrap/InputGroup";
import Validator, {CustomRule, RequiredRule} from 'devextreme-react/validator';
import RetroFormItem from "../../RetroAssets.System/FormGroup";

//_ShortTermRentalDetails
function PropertyShortTermRentalDetails(props) {
    const {show, externalId, readOnly, property} = props
    const [showModal, setShowModal] = useState(false);
    const [activatedTabs, setActivatedTabs] = useState([]);

    const statusRef = useRef(null)
    const [shortTermRentalDetails, setShortTermRentalDetails] = useState({})
    const [gridHeight, setGridHeight] = useState(0)
    const validationGroup = useRef(null)
    const searchBoxRef = useRef(null)
    const [allAgents, setAllAgents] = useState([])

    const strTransactionGridInstance = useRef(null)
    const strTransactionSpanString = "ShortTermRentalTransactions"
    const [strTransactionData, setStrTransactionData] = useState([]);
    const [strTransactionColumns, setStrTransactionColumns] = useState([]);
    const [strTransactionCustomization, setStrTransactionCustomization] = useState({});
    const [strTransactionEditedData, setStrTransactionEditedData] = useState([]);
    const [deletedStrTransaction, setDeletedStrTransaction] = useState([]);


    let attachmentSpanString = "ShortTermRental_Documents"
    let fileAttachmentCounter = 0;
    let attachedFileCount = 0;
    let attachmentValueChangedEventExecuted = false;
    const attachmentButtonInstance = useRef(null);

    const faGridInstance = useRef(null);
    const [faData, setFaData] = useState([])
    const [faColumns, setFaColumns] = useState([])
    const [faGridCustomization, setFaGridCustomization] = useState({})
    const [faEditedData, setFaEditedData] = useState([]);
    const [deletedFileAttachments, setDeletedFileAttachments] = useState([]);
    const [attachedFileList, setAttachedFileList] = useState([])
    const [newItemIndex, setNewItemIndex] = useState(0)

    const modalClose = () => {
        setActivatedTabs(["Details"])
        setShortTermRentalDetails({})
        props.handleClose()
        resetAttachmentControl()
        setShortTermRentalDetails({})
        setFaData([])
        setShowModal(false);
        setFaEditedData([])
        setDeletedFileAttachments([])
        setAttachedFileList([])
        setNewItemIndex(0)
        setStrTransactionEditedData([])
        setDeletedStrTransaction([])
    }

    useEffect(() => {
        if (!show) return
        setShowModal(true)
        LoaderService.setData(true)
        let params = new URLSearchParams({
            externalId: externalId
        })
        apiClient
            .get('/Property/GetShortTermRentalDetails?' + params)
            .then(response => {
                try {
                    let data = JSON.parse(response.data)
                    const strData = data[0]['ShortTermRentalDetails'].Data;
                    if (!externalId) {
                        strData.Property = cl.getEcoIdFromExternalId(property);
                        strData.Month = new Date().getMonth() + 1;
                        strData.Year = new Date().getFullYear();
                        strData.Status = "Open";
                    } else {
                        strData.Property = cl.getEcoIdFromExternalId(property);
                        strData.Property = cl.getEcoIdFromExternalId(strData.Property)
                        strData.Agent = cl.getEcoIdFromExternalId(strData.Agent);
                        if (strData["Settled"])
                            strData.Status = "Settled";
                        else
                            strData.Status = "Open";
                    }
                    if (strData["Settled"])
                        statusRef.current.instance().option("inputAttr", {style: "color: rgba(0, 128, 0, 0.53); font-weight: bold;"});
                    else
                        statusRef.current.instance().option("inputAttr", {style: "color: rgba(255, 0, 0, 1); font-weight: bold;"});


                    setShortTermRentalDetails(strData)

                    let strtData = data[1]["ShortTermRentalTransactions"]
                    setStrTransactionData(strtData[0]["Data"])
                    let settings = strtData[1]["Settings"]
                    setStrTransactionColumns(settings[0][strTransactionSpanString][0]["Columns"])
                    let gc = settings[0][strTransactionSpanString][3]["GridCustomization"][0]
                    if (readOnly) {
                        gc["editing"]["allowUpdating"] = false;
                    }
                    setStrTransactionCustomization(gc)

                    setAllAgents(data[2]['Agents'])


                    let el = document.getElementById("ManageShortTermRental_DetailsTab").clientHeight
                    setGridHeight(el - 52)
                    validationGroup.current.instance().reset()
                    LoaderService.setData(false)
                } catch (e) {
                    LoaderService.setData(false)
                    return alert(response.data, 'Error!')
                }

            })
            .catch(err => {
                LoaderService.setData(false)
                console.log(err)
                return alert(err, 'Error!')
            })
    }, [show])

    //#region Popup & Details Form
    const tabSelectionChanged = e => {
        const index = activatedTabs.findIndex(x => x === e);
        if (index > -1) {
            return;
        }
        setActivatedTabs(oldArray => [...oldArray, e]);
        let url = ""
        if (e === "Attachments") {
            let params = new URLSearchParams({
                externalId: externalId,
                objectType: "Transaction"
            })
            url = "/Property/GetShortTermRentalFileAttachments?" + params
        }
        if (!url)
            return;
        LoaderService.setData(true)
        apiClient
            .get(url)
            .then(response => {
                try {
                    let data = JSON.parse(response.data)
                    setFaData(data[0]["Data"] ?? [])
                    let settings = data[1]["Settings"]
                    setFaColumns(settings[0][attachmentSpanString][0]["Columns"])
                    let gc = settings[0][attachmentSpanString][3]["GridCustomization"][0]
                    setFaGridCustomization(cl.enableDisableDataGridEditing(gc, null))
                    LoaderService.setData(false)
                } catch (e) {
                    LoaderService.setData(false)
                    return alert(response.data, 'Error!')
                }

            })
            .catch(err => {
                LoaderService.setData(false)
                console.log(err)
                return alert(err, 'Error!')
            })
    }

    const valueChangeHandler = e => {
        if (!e.event) return
        let prop = e.component.option("property")
        setShortTermRentalDetails({
            ...shortTermRentalDetails,
            [prop]: e.value
        })
    }

    //#endregion

    //#region Short Term Rental Transaction

    const strTransactionCellPrepared = e => {
        cl.setColumnColorsFromVM(e)
        cl.setHeaderTooltip(e)
    }

    const strTransactionRowValidating = e => {
        setStrTransactionEditedData(cl.rowValidatingEvent(e, strTransactionEditedData))
    }

    const strTransactionNewRowInit = useCallback(e => {
        let nwIndex = newItemIndex + 1;
        e.data["externalId"] = `NNNN${nwIndex}`;
        e.data["Index"] = strTransactionData.length + 1;
        setNewItemIndex(nwIndex)
    }, [strTransactionData, newItemIndex])

    const strTransactionAddRow = () => {
        strTransactionGridInstance.current.instance().addRow();
    }

    const deleteStrTransaction = useCallback((e) => {
        confirm("Are you sure you wish to delete?", "Warning!").then(resp => {
            if (resp) {
                let index = strTransactionEditedData.findIndex(x => x["externalId"] === e.row.key)
                if (index > -1) {
                    strTransactionEditedData.splice(index, 1)
                    setStrTransactionEditedData(strTransactionEditedData)
                }

                index = strTransactionData.findIndex(x => x["externalId"] === e.row.key)
                if (index > -1) {
                    strTransactionData.splice(index, 1)
                    strTransactionGridInstance.current.instance().option("dataSource", strTransactionData)
                    setStrTransactionData(strTransactionData)
                }

                strTransactionGridInstance.current.instance().repaint()
                if (e.row.key.includes("NNNN")) return

                deletedStrTransaction.push(e.row.key)
                setDeletedStrTransaction(deletedStrTransaction)
            }
        })
    }, [strTransactionEditedData, deletedStrTransaction, strTransactionData])


    //#endregion

    //#region File Attachments
    const fileAttachmentsClearFilter = () => {
        faGridInstance.current?.instance().clearFilter()
        faGridInstance.current?.instance().searchByText('')
        searchBoxRef.current?.instance().option('value', null)
    }

    const searchFaByText = e => {
        if (!e.event) return
        faGridInstance.current?.instance().searchByText(e.value ? e.value : null)
    }

    const fileUploaded = useCallback((e => {
        if (e.value.length === 0) return;
        let nwIndex = newItemIndex;
        e.value.forEach((val, index) => {
            let ind = `NNNN${index}`;
            faData.push({
                Name: val.name,
                DocumentType: '',
                externalId: ind,
                DocumentLanguage: '',
                ExpiryDate: null,
                Status: '',
                isNew: true,
            });
            e.value[index]['uniqueId'] = ind;
            attachedFileList.push({uniqueId: ind, value: val})
            nwIndex++
        });
        setFaData(faData);
        setNewItemIndex(nwIndex)
        setAttachedFileList(attachedFileList)
        faGridInstance.current.instance().refresh();
    }), [faData, newItemIndex, attachedFileList])

    function resetAttachmentControl() {
        attachmentValueChangedEventExecuted = true;
        attachmentButtonInstance.current.instance().reset();
        attachmentValueChangedEventExecuted = false;
        attachedFileCount = 0;
        fileAttachmentCounter = 0;
    }

    const executeAttachmentCommands = useCallback(() => {
        attachmentButtonInstance.current.instance()._isCustomClickEvent = true;
        attachmentButtonInstance.current.instance()['_$fileInput'][0].click();
    }, []);

    const selectionChangedFileAttachments = e => {
        cl.singleSelectionCheckbox(e);
    };

    const cellPreparedFileAttachments = e => {
        cl.setHeaderTooltip(e);
    };

    const faRowValidating = e => {
        setFaEditedData(cl.rowValidatingEvent(e, faEditedData));
    };

    const attachFile = () => {
        executeAttachmentCommands()
    }

    const buttonDownloadFile = (e) => {
        faGridInstance.current?.instance().selectRows([e.row.key], false)
        return downloadSelected()
    }

    const downloadSelected = () => {
        let ids = faGridInstance.current.instance().getSelectedRowKeys();
        if (ids.length === 0) return alert("Please select one or more files to download.", "Warning!")
        LoaderService.setData(true)
        let params = new URLSearchParams({
            externalIds: ids.toString(),
            objectType: 'ShortTermRental',
            rootObjectExternalId: externalId
        })

        apiClient
            .get('/Shared/GenerateDocumentsReport?' + params)
            .then(response => {
                try {
                    let resp = JSON.parse(response.data)
                    LoaderService.setData(false)
                    if (resp[0].response) {
                        let path = baseUrl() + resp[0]['message'];
                        let win = window.open(path, '_blank');
                        win.focus();
                    } else {
                        return alert(resp[0].message + '<br /><br /><i>[TIP: Most errors in file downloads are caused by popup blockers.' +
                            '<br />Kindly configure your browser to allow popups if errors persist.</i>', 'Warning!');
                    }
                    LoaderService.setData(false)
                } catch (e) {
                    LoaderService.setData(false)
                    return alert(response.data, 'Error!')
                }

            })
            .catch(err => {
                LoaderService.setData(false)
                console.log(err)
                return alert(err, 'Error!')
            })
    }

    const deleteFileAttachment = useCallback((e) => {
        confirm("Are you sure you wish to delete?", "Warning!").then(resp => {
            if (resp) {
                let index = faEditedData.findIndex(x => x["externalId"] === e.row.key)
                if (index > -1) {
                    faEditedData.splice(index, 1)
                    setFaEditedData(faEditedData)
                }

                index = attachedFileList.findIndex(x => x["externalId"] === e.row.key)
                if (index > -1) {
                    attachedFileList.splice(index, 1)
                    setAttachedFileList(attachedFileList)
                }

                index = faData.findIndex(x => x["externalId"] === e.row.key)
                if (index > -1) {
                    faData.splice(index, 1)
                    faGridInstance.current.instance().option("dataSource", faData)
                    setFaData(faData)
                }

                faGridInstance.current.instance().repaint()
                if (e.row.key.includes("NNNN")) return

                let items = attachmentButtonInstance.current.instance().option('value');
                index = items.findIndex(x => x["uniqueId"] === e.row.key)
                if (index > -1) {
                    items.splice(index, 1)
                    attachmentButtonInstance.current.instance().option('value', items);
                }
                deletedFileAttachments.push(e.row.key)
                setDeletedFileAttachments(deletedFileAttachments)
            }
        })
    }, [faEditedData, deletedFileAttachments, faData, attachedFileList])

    //#endregion

    const saveButtonClicked = () => {
        if (!validationGroup.current.instance().validate().isValid) {
            return
        }
        if (strTransactionData.length === 0) {
            return alert("Please add at least one transaction.", "Warning!")
        }
        saveData()
    }

    const saveData = () => {
        LoaderService.setData(true);
        let formData = new FormData();
        formData.append('ShortTermRentalData', JSON.stringify(shortTermRentalDetails));
        formData.append('ShortTermRentalSpanString', '_ShortTermRentalDetails');
        formData.append('ShortTermRentalTransactionData', JSON.stringify(strTransactionEditedData));
        formData.append('ShortTermRentalTransactionSpanString', strTransactionSpanString);
        formData.append('DeletedShortTermRental', JSON.stringify(deletedStrTransaction));
        formData.append('settled', 'false');
        formData.append('FileAttachmentData', JSON.stringify(faData));
        formData.append(
            'FileAttachmentEditedData',
            JSON.stringify([{spanString: attachmentSpanString, editedData: faEditedData}]),
        );
        formData.append('DeletedFileAttachments', JSON.stringify(deletedFileAttachments));
        attachedFileList.forEach(val => {
            formData.append(val['uniqueId'], val['value'], val['uniqueId'])
        })
        apiClient
            .post('/Property/AddUpdateShortTermRentals', formData)
            .then(response => {
                if (response) {
                    try {
                        LoaderService.setData(false);
                        let resp = JSON.parse(response.data);
                        resetAttachmentControl();
                        modalClose();
                        if (resp[0].response) {
                            props.isUpdated();
                        } else {
                            return alert(resp[0].message, 'Warning!');
                        }

                    } catch (e) {
                        resetAttachmentControl();
                        modalClose();
                        LoaderService.setData(false);
                        return alert(response.data, 'Error!');
                    }
                }
            })
            .catch(err => {
                LoaderService.setData(false);
                console.log(err);
            });
    }

    return (<Modal show={showModal} onHide={modalClose} centered dialogClassName="modal-70w prop-img-slider"
                   backdrop="static" keyboard={false}>
            <Modal.Header closeButton className="border-0 pb-0 modal-header">
                <Modal.Title className="fs-5 fw-bold">
                    <span>MANAGE SHORT TERM RENTAL DETAILS</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="pt-2">
                <FileUploader
                    style={{display: 'none'}}
                    ref={attachmentButtonInstance}
                    multiple={true}
                    accept=".pdf, .xlsx, .xls, .doc, .docx, .txt, .jpg, .png, .bmp"
                    labelText=""
                    allowCanceling={false}
                    showFileList={false}
                    selectButtonText="Add Documents"
                    onValueChanged={fileUploaded}
                    uploadMode="useForm"
                ></FileUploader>
                <Tabs defaultActiveKey="Details" className="fs-6 nav-tab tab-sm inner-tab"
                      onSelect={tabSelectionChanged}>
                    <Tab eventKey="Details" title="Details">
                        <div className="py-2 tabs-border" id="ManageShortTermRental_DetailsTab">
                            <div className="row tabsContent">
                                <ValidationGroup ref={validationGroup}>
                                    <div className="col-sm-12">
                                        <div className="row">
                                            {/*Status*/}
                                            <div className="col-sm-4 col-md-2">
                                                <RetroFormItem
                                                    label={"Status"}
                                                    mandatory={false}
                                                    valueField={
                                                        <TextBox
                                                            ref={statusRef}
                                                            inputAttr={{class: "form-control"}}
                                                            elementAttr={{class: "input-group"}}
                                                            placeholder="Status"
                                                            value={shortTermRentalDetails["Status"]}
                                                            readOnly={true}
                                                        />}
                                                ></RetroFormItem>
                                            </div>
                                            {/*FromDate*/}
                                            <div className="col-sm-4 col-md-2">
                                                <RetroFormItem
                                                    label={"From Date"}
                                                    mandatory={true}
                                                    valueField={
                                                        <DateBox
                                                            inputAttr={{class: "form-control"}}
                                                            elementAttr={{class: "input-group"}}
                                                            placeholder="From Date"
                                                            displayFormat={'dd/MM/yyyy'}
                                                            value={shortTermRentalDetails["FromDate"]}
                                                            readOnly={readOnly}
                                                            property="FromDate"
                                                            onValueChanged={valueChangeHandler}
                                                        >
                                                            <Validator>
                                                                <RequiredRule type={'required'}
                                                                              message={'From Date is cannot be empty.'}>
                                                                </RequiredRule>
                                                            </Validator>
                                                        </DateBox>}
                                                ></RetroFormItem>
                                            </div>
                                            {/*ToDate*/}
                                            <div className="col-sm-4 col-md-2">
                                                <RetroFormItem
                                                    label={"To Date"}
                                                    mandatory={true}
                                                    valueField={
                                                        <DateBox
                                                            inputAttr={{class: "form-control"}}
                                                            elementAttr={{class: "input-group"}}
                                                            placeholder="To Date"
                                                            displayFormat={'dd/MM/yyyy'}
                                                            value={shortTermRentalDetails["ToDate"]}
                                                            readOnly={readOnly}
                                                            property="ToDate"
                                                            onValueChanged={valueChangeHandler}
                                                        >
                                                            <Validator>
                                                                <RequiredRule type={'required'}
                                                                              message={'To Date is cannot be empty.'}>
                                                                </RequiredRule>
                                                            </Validator>
                                                        </DateBox>}
                                                ></RetroFormItem>
                                            </div>
                                            {/*RentalAgency*/}
                                            <div className="col-sm-12 col-md-6">
                                                <RetroFormItem
                                                    label={"Rental Agency"}
                                                    mandatory={false}
                                                    valueField={
                                                        <SelectBox
                                                            dataSource={allAgents}
                                                            displayExpr={"Name"}
                                                            valueExpr={"externalId"}
                                                            inputAttr={{class: "form-control"}}
                                                            elementAttr={{class: "input-group"}}
                                                            placeholder="Rental Agency"
                                                            property="Agent"
                                                            onValueChanged={valueChangeHandler}
                                                            value={shortTermRentalDetails["Agent"]}
                                                            readOnly={readOnly}
                                                        />}
                                                ></RetroFormItem>
                                            </div>
                                            {/*Remarks*/}
                                            <div className="col-sm-12 col-md-12">
                                                <RetroFormItem
                                                    label={"Remarks"}
                                                    mandatory={false}
                                                    valueField={
                                                        <TextBox
                                                            inputAttr={{class: "form-control"}}
                                                            elementAttr={{class: "input-group"}}
                                                            placeholder="Remarks"
                                                            property="Remarks"
                                                            onValueChanged={valueChangeHandler}
                                                            value={shortTermRentalDetails["Remarks"]}
                                                            readOnly={readOnly}
                                                        />}
                                                ></RetroFormItem>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="row">
                                            {readOnly ? <></> : <div
                                                className="d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center mb-2">
                                                <div className="d-sm-flex align-items-center justify-content-between">

                                                </div>
                                                <div className="d-flex">
                                                    <Button
                                                        variant="outline-primary"
                                                        className="flex-shrink-0 me-3"
                                                        onClick={strTransactionAddRow}
                                                    >
                                                        Add
                                                    </Button>
                                                </div>
                                            </div>}
                                            <DataGrid
                                                ref={strTransactionGridInstance}
                                                dataSource={strTransactionData}
                                                {...strTransactionCustomization}
                                                keyExpr="externalId"
                                                height={450}
                                                onCellPrepared={strTransactionCellPrepared}
                                                onRowValidating={strTransactionRowValidating}
                                                onInitNewRow={strTransactionNewRowInit}
                                            >
                                                {strTransactionColumns.map((column, i) => (
                                                    cl.generateReactColumnsFromJson(column)
                                                ))}
                                                {strTransactionColumns.map((column, i) => (
                                                    cl.generateActionButtonColumn(column)
                                                ))}
                                                <Column
                                                    type="buttons"
                                                    width="8%"
                                                >
                                                    {readOnly ?
                                                        <></> :
                                                        <DataGridButton
                                                            icon={"trash"}
                                                            visible={true}
                                                            onClick={deleteStrTransaction}
                                                        ></DataGridButton>
                                                    }
                                                </Column>
                                                <Summary>
                                                    <TotalItem
                                                        column="Amount"
                                                        summaryType="sum"
                                                        valueFormat={"#,#00.00"}
                                                    />
                                                </Summary>
                                                <Template name="myTemplate" render={MoreOptionsButton}/>
                                                <Template name="contextMenuTemplate" render={ContextMenuTemplate}/>
                                            </DataGrid>
                                        </div>
                                    </div>
                                </ValidationGroup>
                            </div>
                        </div>
                    </Tab>
                    <Tab eventKey="Attachments" title="Attachments">
                        <div className="py-2 tabs-border">
                            <div className="row tabsContent">
                                <div
                                    className="d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center mb-2">
                                    <h4 className="fs-4 fw-medium mb-3 mb-sm-0"></h4>
                                    <div className="d-flex">
                                        <Button variant="outline-primary" className="flex-shrink-0 me-3"
                                                onClick={fileAttachmentsClearFilter}>
                                            Clear Filter
                                        </Button>
                                        <Button variant="outline-primary" className="flex-shrink-0 me-3"
                                                onClick={downloadSelected}>
                                            Download
                                        </Button>
                                        {readOnly ? <></> :
                                            <Button variant="outline-primary" className="flex-shrink-0 me-3"
                                                    onClick={attachFile}>
                                                Add Documents
                                            </Button>}
                                        <InputGroup className="me-3 search-input">
                                            <TextBox
                                                ref={searchBoxRef}
                                                placeholder="Search Documents..."
                                                mode="search"
                                                inputAttr={{class: "form-control"}}
                                                elementAttr={{class: "search-input input-group"}}
                                                width="100%"
                                                onValueChanged={searchFaByText}
                                            ></TextBox>
                                        </InputGroup>
                                    </div>
                                </div>
                                <DataGrid
                                    ref={faGridInstance}
                                    keyExpr="externalId"
                                    dataSource={faData}
                                    // columns={faColumns}
                                    height={gridHeight}
                                    onCellPrepared={cellPreparedFileAttachments}
                                    onRowValidating={faRowValidating}
                                    onSelectionChanged={selectionChangedFileAttachments}
                                    {...faGridCustomization}
                                >
                                    {faColumns.map(column => (cl.generateReactColumnsFromJson(column)))}
                                    <Column
                                        type="buttons"
                                        width="8%"
                                    >
                                        {readOnly ?
                                            <></> :
                                            <DataGridButton
                                                icon={"trash"}
                                                visible={true}
                                                onClick={deleteFileAttachment}
                                            ></DataGridButton>
                                        }
                                        <DataGridButton
                                            icon="chevrondown"
                                            visible={true}
                                            onClick={buttonDownloadFile}
                                        ></DataGridButton>
                                    </Column>
                                    <Template name="contextMenuTemplate" render={ContextMenuTemplate}/>
                                    <Template name="myTemplate" render={MoreOptionsButton}/>
                                </DataGrid>
                            </div>
                        </div>
                    </Tab>
                </Tabs>
            </Modal.Body>
            <Modal.Footer className="pt-2">
                {readOnly ? <Button variant="outline-primary" className="flex-shrink-0 me-3"
                                    onClick={modalClose}>
                    Close
                </Button> : <>
                    <Button variant="outline-primary" className="flex-shrink-0 me-3"
                            onClick={saveButtonClicked}>
                        Save
                    </Button>
                    <Button variant="outline-primary" className="flex-shrink-0 me-3"
                            onClick={modalClose}>
                        Cancel
                    </Button>
                </>}
            </Modal.Footer>

        </Modal>
    )
}

export default PropertyShortTermRentalDetails;